import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { logErrorAndRunFail } from '../../utils';

export interface RemoveStorageOption extends Partial<GeneralInvokeOption> {
  key: string;
}

// 从本地缓存中移除指定key
export function removeStorage(option: RemoveStorageOption) {
  if (!option?.key) {
    return logErrorAndRunFail(
      APINames.Native.REMOVE_STORAGE,
      option,
      'parameter error:parameter.key should be String instead of Undefined.'
    );
  }
  return MacleJSBridge.beforeInvoke(APINames.Native.REMOVE_STORAGE, option);
}
